import React, { useState } from "react";

interface TeamCrestProps {
  name: string;
  logoUrl?: string | null;
  size?: number;
  className?: string;
}

// Renders a team logo, falling back to a monogram badge when the logo is
// missing (manual matches / legacy synced matches) or fails to load.
const TeamCrest: React.FC<TeamCrestProps> = ({
  name,
  logoUrl,
  size = 22,
  className = "",
}) => {
  const [failed, setFailed] = useState(false);

  const initials =
    name === "TBD"
      ? "?"
      : name
          .replace(/[^A-Za-z0-9\s]/g, "")
          .trim()
          .split(/\s+/)
          .map((w) => w[0])
          .join("")
          .slice(0, 2)
          .toUpperCase() || "?";

  const dim = { width: size, height: size };

  if (logoUrl && !failed) {
    return (
      <img
        src={logoUrl}
        alt={name}
        loading="lazy"
        onError={() => setFailed(true)}
        style={dim}
        className={`object-contain shrink-0 ${className}`}
      />
    );
  }

  return (
    <span
      style={dim}
      aria-label={name}
      className={`shrink-0 inline-flex items-center justify-center rounded-md bg-white/10 text-white/50 font-heading font-bold leading-none ${className}`}
    >
      <span style={{ fontSize: Math.round(size * 0.42) }}>{initials}</span>
    </span>
  );
};

export default TeamCrest;
